import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';

export const CLIENTS_DETAILS_ROUTE = 'details';
export const CLIENTS_BANK_DETAILS_ROUTE = 'bank-details';
export const CLIENTS_ACTIVITY_ROUTE = 'activity';
export const CLIENTS_JOBS_ROUTE = 'jobs';
export const CLIENT_ACCEPT_VERSION = '2.5.0';
export const CLIENT_SEARCH_ACCEPT_VERSION = '2.5.0';
export const CLIENT_DOCUMENTS_ACCEPT_VERSION = '1.0.0';
export const FIX_BILLING_ADDRESS_ACTION_QUERY_PARAM = 'fix_billing_address';
export const FIX_SHIPPING_ADDRESS_ACTION_QUERY_PARAM = 'fix_shipping_address';
export const CLIENT_LIST_SEARCH_PARAMS_KEY = 'client_list_search_params';

export enum DocumentHistoryFilterTypesEnum {
  all_documents = 'all_documents',
  overdue = 'overdue',
  unpaid = 'unpaid',
  invoices = 'invoices',
  estimates = 'estimates',
  purchase_orders = 'purchase_orders',
  credit_memos = 'credit_memos',
}

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.billing_name,
  sort_order: SortOrderEnum.asc,
});

export const CLIENT_DOCUMENTS_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.doc_date,
  sort_order: SortOrderEnum.desc,
});
